import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Accordion, Layout, Select, Tabs, WordCloud } from '@utilities';

import NoDataPlaceholder from '../NoDataPlaceholder';
import OpenEndedTable from './components/OpenEndedTable';

const OpenEnded = ({ data, question, renderResponseTextSummary }) => {
  const conceptOptions = useMemo(
    () =>
      (question?.concepts || [])
        .filter(({ id, name }) => id !== null && id !== undefined && name)
        .map(({ id, name }) => ({ label: name, value: id })),
    [question?.concepts]
  );
  const [selectedConceptValue, setSelectedConceptValue] = useState(
    () => conceptOptions[0]?.value ?? null
  );
  const [selectedSegmentId, setSelectedSegmentId] = useState(() => data?.segments?.[0]?.id);
  const selectedConcept =
    conceptOptions.find(({ value }) => value === selectedConceptValue) || conceptOptions[0] || null;

  useEffect(() => {
    setSelectedSegmentId(data?.segments?.[0]?.id);
  }, [data?.segments]);

  useEffect(() => {
    setSelectedConceptValue(conceptOptions[0]?.value ?? null);
  }, [conceptOptions]);

  const groupSegment = data?.segments?.find((segment) => segment.id === selectedSegmentId);
  if (!groupSegment) return <NoDataPlaceholder />;

  const wordCloudData = groupSegment.chart?.series[0]?.data?.map((point) => ({ ...point })) || [];

  return (
    <Layout.Flex.Column>
      {conceptOptions.length > 0 && (
        <Select
          data-testid="open-ended-concept-select"
          label="Concept"
          onChange={(option) => setSelectedConceptValue(option?.value ?? null)}
          options={conceptOptions}
          value={selectedConcept}
        />
      )}
      <Tabs
        onChange={setSelectedSegmentId}
        options={data.segments?.map(({ id, name }) => ({ label: name, value: id }))}
        value={selectedSegmentId}
      />
      <Accordion isDefaultOpen label="Show/Collapse Word Cloud">
        <WordCloud data={wordCloudData} key={groupSegment.id} />
      </Accordion>
      {renderResponseTextSummary({ question, segment: groupSegment })}
      <OpenEndedTable columns={groupSegment.table.columns} data={groupSegment.table.data} />
    </Layout.Flex.Column>
  );
};

OpenEnded.propTypes = {
  data: PropTypes.object,
  question: PropTypes.object,
  renderResponseTextSummary: PropTypes.func,
};

export default OpenEnded;
